import React, { useContext, useEffect, useState } from "react";
import Sessions from "../../../common/Chat/Sessions";
import AppContext from "../../../../AppContext";
import Chat from "../../../common/Chat";
import ChatSessionContext from "../../../../contexts/ChatSessionContext";

const ChatHistory = () => {
  const { user } = useContext(AppContext);
  const { currentSession, setCurrentSession } = useContext(ChatSessionContext);

  useEffect(() => {
    return () => {
      setCurrentSession(undefined);
    };
  }, []);

  const handleSessionSelect = (session) => {
    setCurrentSession(session);
  };

  return (
    <div className="admin-chat-history">
      <div className="admin-chat-history-session">
        <Sessions
          userId={user._id}
          support={true}
          onSelectSession={handleSessionSelect}
        />
      </div>
      <div className="admin-chat-history-chat">
        {currentSession && (
          <Chat userId={user._id} mini={false} sessionId={currentSession} />
        )}
      </div>
    </div>
  );
};

ChatHistory.propTypes = {};

export default ChatHistory;
